import { render, staticRenderFns } from "./HorseArchivedList.vue?vue&type=template&id=432e9b57&"
import script from "./HorseArchivedList.vue?vue&type=script&lang=js&"
export * from "./HorseArchivedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports